/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkLicenseUpdateResult} from '../models/BulkLicenseUpdateResult';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {LicenseBulkUpdateRequest} from '../models/LicenseBulkUpdateRequest';

export interface DisableLicensesModules$Request {
    licenseBulkUpdateRequest: LicenseBulkUpdateRequest;
    reason?: string;
}

export interface DisableLicensesModules$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const disableLicensesModulesRequest = createAction<PayloadData<void, DisableLicensesModules$Request>>('BULK_LICENSES_MODULES__DISABLE_LICENSES_MODULES__REQUEST');
export const disableLicensesModulesSuccess = createAction<PayloadData<string, DisableLicensesModules$Request>>('BULK_LICENSES_MODULES__DISABLE_LICENSES_MODULES__SUCCESS');
export const disableLicensesModulesFailure = createAction<PayloadData<Error, DisableLicensesModules$Request, true>>('BULK_LICENSES_MODULES__DISABLE_LICENSES_MODULES__FAILURE');

export const disableLicensesModulesActions = [
    disableLicensesModulesRequest,
    disableLicensesModulesSuccess,
    disableLicensesModulesFailure
] as const;

/**
 * @param {LicenseBulkUpdateRequest} meta.licenseBulkUpdateRequest
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const disableLicensesModules = (meta: DisableLicensesModules$Request, config?: DisableLicensesModules$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: disableLicensesModulesActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/bulk-actions/licenses/disable-modules`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.licenseBulkUpdateRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface EnabledLicensesModules$Request {
    licenseBulkUpdateRequest: LicenseBulkUpdateRequest;
    reason?: string;
}

export interface EnabledLicensesModules$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const enabledLicensesModulesRequest = createAction<PayloadData<void, EnabledLicensesModules$Request>>('BULK_LICENSES_MODULES__ENABLED_LICENSES_MODULES__REQUEST');
export const enabledLicensesModulesSuccess = createAction<PayloadData<string, EnabledLicensesModules$Request>>('BULK_LICENSES_MODULES__ENABLED_LICENSES_MODULES__SUCCESS');
export const enabledLicensesModulesFailure = createAction<PayloadData<Error, EnabledLicensesModules$Request, true>>('BULK_LICENSES_MODULES__ENABLED_LICENSES_MODULES__FAILURE');

export const enabledLicensesModulesActions = [
    enabledLicensesModulesRequest,
    enabledLicensesModulesSuccess,
    enabledLicensesModulesFailure
] as const;

/**
 * @param {LicenseBulkUpdateRequest} meta.licenseBulkUpdateRequest
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const enabledLicensesModules = (meta: EnabledLicensesModules$Request, config?: EnabledLicensesModules$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: enabledLicensesModulesActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/bulk-actions/licenses/enabled-modules`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.licenseBulkUpdateRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetDisabledLicensesModulesProgress$Request {
    id: string;
}

export interface GetDisabledLicensesModulesProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDisabledLicensesModulesProgressRequest = createAction<PayloadData<void, GetDisabledLicensesModulesProgress$Request>>('BULK_LICENSES_MODULES__GET_DISABLED_LICENSES_MODULES_PROGRESS__REQUEST');
export const getDisabledLicensesModulesProgressSuccess = createAction<PayloadData<BulkProgress, GetDisabledLicensesModulesProgress$Request>>('BULK_LICENSES_MODULES__GET_DISABLED_LICENSES_MODULES_PROGRESS__SUCCESS');
export const getDisabledLicensesModulesProgressFailure = createAction<PayloadData<Error, GetDisabledLicensesModulesProgress$Request, true>>('BULK_LICENSES_MODULES__GET_DISABLED_LICENSES_MODULES_PROGRESS__FAILURE');

export const getDisabledLicensesModulesProgressActions = [
    getDisabledLicensesModulesProgressRequest,
    getDisabledLicensesModulesProgressSuccess,
    getDisabledLicensesModulesProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDisabledLicensesModulesProgress = (meta: GetDisabledLicensesModulesProgress$Request, config?: GetDisabledLicensesModulesProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getDisabledLicensesModulesProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/licenses/disable-modules/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetDisabledLicensesModulesResult$Request {
    id: string;
}

export interface GetDisabledLicensesModulesResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDisabledLicensesModulesResultRequest = createAction<PayloadData<void, GetDisabledLicensesModulesResult$Request>>('BULK_LICENSES_MODULES__GET_DISABLED_LICENSES_MODULES_RESULT__REQUEST');
export const getDisabledLicensesModulesResultSuccess = createAction<PayloadData<BulkLicenseUpdateResult, GetDisabledLicensesModulesResult$Request>>('BULK_LICENSES_MODULES__GET_DISABLED_LICENSES_MODULES_RESULT__SUCCESS');
export const getDisabledLicensesModulesResultFailure = createAction<PayloadData<Error, GetDisabledLicensesModulesResult$Request, true>>('BULK_LICENSES_MODULES__GET_DISABLED_LICENSES_MODULES_RESULT__FAILURE');

export const getDisabledLicensesModulesResultActions = [
    getDisabledLicensesModulesResultRequest,
    getDisabledLicensesModulesResultSuccess,
    getDisabledLicensesModulesResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDisabledLicensesModulesResult = (meta: GetDisabledLicensesModulesResult$Request, config?: GetDisabledLicensesModulesResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getDisabledLicensesModulesResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/licenses/disable-modules`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetEnabledLicensesModulesProgress$Request {
    id: string;
}

export interface GetEnabledLicensesModulesProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getEnabledLicensesModulesProgressRequest = createAction<PayloadData<void, GetEnabledLicensesModulesProgress$Request>>('BULK_LICENSES_MODULES__GET_ENABLED_LICENSES_MODULES_PROGRESS__REQUEST');
export const getEnabledLicensesModulesProgressSuccess = createAction<PayloadData<BulkProgress, GetEnabledLicensesModulesProgress$Request>>('BULK_LICENSES_MODULES__GET_ENABLED_LICENSES_MODULES_PROGRESS__SUCCESS');
export const getEnabledLicensesModulesProgressFailure = createAction<PayloadData<Error, GetEnabledLicensesModulesProgress$Request, true>>('BULK_LICENSES_MODULES__GET_ENABLED_LICENSES_MODULES_PROGRESS__FAILURE');

export const getEnabledLicensesModulesProgressActions = [
    getEnabledLicensesModulesProgressRequest,
    getEnabledLicensesModulesProgressSuccess,
    getEnabledLicensesModulesProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getEnabledLicensesModulesProgress = (meta: GetEnabledLicensesModulesProgress$Request, config?: GetEnabledLicensesModulesProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getEnabledLicensesModulesProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/licenses/enabled-modules/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetEnabledLicensesModulesResult$Request {
    id: string;
}

export interface GetEnabledLicensesModulesResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getEnabledLicensesModulesResultRequest = createAction<PayloadData<void, GetEnabledLicensesModulesResult$Request>>('BULK_LICENSES_MODULES__GET_ENABLED_LICENSES_MODULES_RESULT__REQUEST');
export const getEnabledLicensesModulesResultSuccess = createAction<PayloadData<BulkLicenseUpdateResult, GetEnabledLicensesModulesResult$Request>>('BULK_LICENSES_MODULES__GET_ENABLED_LICENSES_MODULES_RESULT__SUCCESS');
export const getEnabledLicensesModulesResultFailure = createAction<PayloadData<Error, GetEnabledLicensesModulesResult$Request, true>>('BULK_LICENSES_MODULES__GET_ENABLED_LICENSES_MODULES_RESULT__FAILURE');

export const getEnabledLicensesModulesResultActions = [
    getEnabledLicensesModulesResultRequest,
    getEnabledLicensesModulesResultSuccess,
    getEnabledLicensesModulesResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getEnabledLicensesModulesResult = (meta: GetEnabledLicensesModulesResult$Request, config?: GetEnabledLicensesModulesResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getEnabledLicensesModulesResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/licenses/enabled-modules`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopDisableLicensesModulesAction$Request {
    id: string;
}

export interface StopDisableLicensesModulesAction$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopDisableLicensesModulesActionRequest = createAction<PayloadData<void, StopDisableLicensesModulesAction$Request>>('BULK_LICENSES_MODULES__STOP_DISABLE_LICENSES_MODULES_ACTION__REQUEST');
export const stopDisableLicensesModulesActionSuccess = createAction<PayloadData<void, StopDisableLicensesModulesAction$Request>>('BULK_LICENSES_MODULES__STOP_DISABLE_LICENSES_MODULES_ACTION__SUCCESS');
export const stopDisableLicensesModulesActionFailure = createAction<PayloadData<Error, StopDisableLicensesModulesAction$Request, true>>('BULK_LICENSES_MODULES__STOP_DISABLE_LICENSES_MODULES_ACTION__FAILURE');

export const stopDisableLicensesModulesActionActions = [
    stopDisableLicensesModulesActionRequest,
    stopDisableLicensesModulesActionSuccess,
    stopDisableLicensesModulesActionFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopDisableLicensesModulesAction = (meta: StopDisableLicensesModulesAction$Request, config?: StopDisableLicensesModulesAction$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopDisableLicensesModulesActionActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/licenses/disable-modules`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopEnabledLicensesModulesAction$Request {
    id: string;
}

export interface StopEnabledLicensesModulesAction$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopEnabledLicensesModulesActionRequest = createAction<PayloadData<void, StopEnabledLicensesModulesAction$Request>>('BULK_LICENSES_MODULES__STOP_ENABLED_LICENSES_MODULES_ACTION__REQUEST');
export const stopEnabledLicensesModulesActionSuccess = createAction<PayloadData<void, StopEnabledLicensesModulesAction$Request>>('BULK_LICENSES_MODULES__STOP_ENABLED_LICENSES_MODULES_ACTION__SUCCESS');
export const stopEnabledLicensesModulesActionFailure = createAction<PayloadData<Error, StopEnabledLicensesModulesAction$Request, true>>('BULK_LICENSES_MODULES__STOP_ENABLED_LICENSES_MODULES_ACTION__FAILURE');

export const stopEnabledLicensesModulesActionActions = [
    stopEnabledLicensesModulesActionRequest,
    stopEnabledLicensesModulesActionSuccess,
    stopEnabledLicensesModulesActionFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopEnabledLicensesModulesAction = (meta: StopEnabledLicensesModulesAction$Request, config?: StopEnabledLicensesModulesAction$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopEnabledLicensesModulesActionActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/licenses/enabled-modules`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

